module.exports = __webpack_public_path__ + "static/media/traineeships-and-aprenticeships.d6f57007.jpg";